import { themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { k8sIconStyles } from "~/areas/projects/components/Observability/K8ResourceIcons/k8sIconStyles";
export function ClusterRoleBindingIcon() {
    return (<svg className={k8sIconStyles} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.03995 20C7.03995 17.264 9.26401 15.04 12 15.04H18.4V12H12C7.58397 12 4 15.584 4 20C4 24.416 7.58397 28 12 28H18.4V24.96H12C9.26401 24.96 7.03995 22.736 7.03995 20ZM13.6 21.6H26.4V18.4H13.6V21.6ZM28 12H21.6V15.04H28C30.736 15.04 32.96 17.264 32.96 20C32.96 22.736 30.736 24.96 28 24.96H21.6V28H28C32.416 28 36 24.416 36 20C36 15.584 32.416 12 28 12Z" fill={themeTokens.color.icon.tertiary}/>
        </svg>);
}
